declare namespace $ {

	type $mol_paragraph__title_giper_balls_shop_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_giper_balls_shop_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_giper_balls_shop_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_giper_balls_shop_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_giper_balls_shop_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_giper_balls_shop_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_giper_balls_shop_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_giper_balls_shop_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_giper_balls_shop_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_giper_balls_shop_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_giper_balls_shop_11 = $mol_type_enforce<
		ReturnType< $giper_balls_shop['buy_1'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_giper_balls_shop_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_giper_balls_shop_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_giper_balls_shop_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_giper_balls_shop_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_giper_balls_shop_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_giper_balls_shop_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_giper_balls_shop_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_giper_balls_shop_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_giper_balls_shop_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_giper_balls_shop_21 = $mol_type_enforce<
		ReturnType< $giper_balls_shop['buy_3'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_giper_balls_shop_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_giper_balls_shop_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_giper_balls_shop_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_giper_balls_shop_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_giper_balls_shop_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_giper_balls_shop_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_giper_balls_shop_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_giper_balls_shop_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_giper_balls_shop_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_giper_balls_shop_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_giper_balls_shop_32 = $mol_type_enforce<
		ReturnType< $giper_balls_shop['buy_5'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_giper_balls_shop_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_giper_balls_shop_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_giper_balls_shop_35 = $mol_type_enforce<
		ReturnType< $giper_balls_shop['checkout_info_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_giper_balls_shop_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__attr_giper_balls_shop_37 = $mol_type_enforce<
		({ 
			'id': string,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_paragraph__title_giper_balls_shop_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $giper_balls_shop extends $mol_page {
		check_pending( ): any
		Info_icon( ): $mol_icon_heart
		Info_text( ): $mol_paragraph
		Info( ): $mol_view
		Description( ): $mol_paragraph
		Product_1_title( ): $mol_paragraph
		Price_1_value( ): $mol_paragraph
		Price_1_currency( ): $mol_paragraph
		Product_1_price( ): $mol_view
		Product_1_note( ): $mol_paragraph
		Product_1_content( ): $mol_view
		buy_1( next?: any ): any
		Buy_1( ): $mol_button_major
		Product_1( ): $mol_view
		Product_3_badge( ): $mol_paragraph
		Product_3_title( ): $mol_paragraph
		Price_3_value( ): $mol_paragraph
		Price_3_currency( ): $mol_paragraph
		Product_3_price( ): $mol_view
		Product_3_note( ): $mol_paragraph
		Product_3_content( ): $mol_view
		buy_3( next?: any ): any
		Buy_3( ): $mol_button_major
		Product_3( ): $mol_view
		Product_5_badge( ): $mol_paragraph
		Product_5_title( ): $mol_paragraph
		Product_5_subtitle( ): $mol_paragraph
		Price_5_value( ): $mol_paragraph
		Price_5_currency( ): $mol_paragraph
		Product_5_price( ): $mol_view
		Product_5_note( ): $mol_paragraph
		Product_5_content( ): $mol_view
		buy_5( next?: any ): any
		Buy_5( ): $mol_button_major
		Product_5( ): $mol_view
		Products( ): $mol_view
		checkout_info_content( ): readonly(any)[]
		Checkout_info( ): $mol_view
		Checkout( ): $mol_view
		Footer( ): $mol_paragraph
		title( ): string
		auto( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=shop.view.tree.d.ts.map